import { useEffect } from 'react';

export function useNoindex() {
  useEffect(() => {
    const metaEl = document.querySelector('meta[name="robots"]');
    const previous = metaEl?.content;
    if (metaEl) metaEl.content = 'noindex, nofollow';
    return () => {
      if (metaEl && previous !== undefined) metaEl.content = previous;
    };
  }, []);
}
